export const MEDIUM_TREE_VIEW_WIDTH = 450;
export const SMALL_TREE_VIEW_WIDTH = 40;
